<template>
 <datepicker :name="inputId"  :id="inputId" :value="dateValue" :format="customFormatter" v-on:selected="updatedDate($event)"  />
</template>
<script>
// import _ from 'lodash'
import $ from 'jQuery'
import Vue from 'vue'
import VeeValidate from 'vee-validate'
import DatePicker from 'vuejs-datepicker'
import moment from 'moment'
import VueMomentJS from 'vue-momentjs'

Vue.use(VueMomentJS, moment)
Vue.use(VeeValidate, { fastExit: false })

let thisData = {
  _date: new Date()
}
const DATE_FORMAT = 'YYYY-MM-DD'
export default {
  inject: ['$validator'],
  mounted: function () {
    // allow the component for manual edition
    const self = this
    let _domId = '#' + this.inputId
    thisData._date = this.value
    $(_domId).removeAttr('readonly')
    $(_domId).attr('maxlength', this.date_format.length)
    $(_domId).bind('paste keyup', function (e) {
      this.value = this.value.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3')
      var date = moment(this.value, this.date_format, true)
      if (this.value.length === DATE_FORMAT.length && date.isValid()) {
        thisData._date = this.value // force the Datepicker update
        self.updatedDate(moment(thisData._date, [DATE_FORMAT, moment.ISO_8601]).toDate())
      } else {
        self.updatedDate(null)
      }
    })
  },
  props: {
    inputId: { type: String },
    label: { type: String },
    value: {
      type: Date,
      default: ''
    },
    index: undefined,
    date_format: {
      default: DATE_FORMAT
    }
  },
  data: function () {
    return thisData
  },
  components: {
    'datepicker': DatePicker
  },
  computed: {
    dateValue: function () {
      if (this.value instanceof Date && !isNaN(this.value.getTime())) {
        return this.value
      }
      return ''
    }
  },
  methods: {
    updatedDate: function (date) {
      console.log('EDITED -> ' + date)
      let index = this.index
      if (date != null) {
        let payload = {index: index, date: date}
        this.$emit('updated', payload)
        this.$emit('input', this.$moment(date).format(DATE_FORMAT))
      } else {
        this.$emit('updated', {index: index, date: ''})
        this.$emit('input', '')
      }
    },
    customFormatter: function (date) {
      return this.$moment(date).format(DATE_FORMAT)
    }
  }
}
</script>



// WEBPACK FOOTER //
// runtime-datepicker.vue?5c86d9e8